
export default function Title({ title, icon }) {
    return (
        <div className="w-full flex items-center">
            <h3 className="text-xl text-gray-800 dark:text-white">{title || null}</h3>
            {icon || null}
        </div>
    )
}